import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import { SerializedError } from '@reduxjs/toolkit'
import { useIntl } from 'react-intl'
import { useState } from 'react'

interface ErrorData {
    code: number
    error: string
}

export const useSpaErrors = () => {
    const { formatMessage } = useIntl()

    const [errorMessage, setErrorMessage] = useState<string | undefined>()
    const [shouldRefetchHours, setShouldRefetchHours] = useState(false)

    const handleError = (error: FetchBaseQueryError | SerializedError) => {
        if (!('status' in error)) return

        // customized error message from api,
        // needs refetching data for currently available hours
        if (error.status === 409 && error.data) {
            const erorrData = error.data as ErrorData
            setErrorMessage(erorrData.error)
            setShouldRefetchHours(true)
            return
        }

        // generic error message
        setErrorMessage(
            formatMessage({
                id: 'global.error.generic_technical_issue',
                defaultMessage: '_',
            })
        )
        setShouldRefetchHours(false)
        return
    }

    return {
        handleError,
        errorMessage,
        setErrorMessage,
        shouldRefetchHours,
        setShouldRefetchHours,
    }
}
